import { useReCaptcha, VueReCaptcha } from 'vue-recaptcha-v3'
import { useNuxtApp, useRuntimeConfig } from 'nuxt/app'

export const useRecaptcha = async () => {
  const { vueApp } = useNuxtApp()
  const config = useRuntimeConfig()
  vueApp.use(VueReCaptcha, {
    siteKey: config.public.googleReCaptchaSiteKey,
    loaderOptions: {
      autoHideBadge: true
    }
  })
  const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()
  await recaptchaLoaded()
  return await executeRecaptcha('login')
}

// export const useRecaptcha = async () => {
//   const {vueApp} = useNuxtApp()
//   const config = useRuntimeConfig()
//
//   console.log(config.public.googleReCaptchaSiteKey)
//   vueApp.use(VueReCaptcha, {
//     siteKey: config.public.googleReCaptchaSiteKey,
//     loaderOptions: {
//       autoHideBadge: true,
//     },
//   })
//
//   const recaptchaInstance = useReCaptcha()
//
//   await recaptchaInstance?.recaptchaLoaded()
//   return recaptchaInstance?.executeRecaptcha('login')
// }
